import { useEffect, useState } from 'react';
export function useIsMouseDown() {
    const [isMouseDown, setIsMouseDown] = useState(false);
    useEffect(() => {
        const mouseDownListener = () => {
            setIsMouseDown(true);
            window.addEventListener('mouseup', () => {
                setIsMouseDown(false);
            }, { once: true });
        };
        window.addEventListener('mousedown', mouseDownListener);
        return () => {
            window.removeEventListener('mousedown', mouseDownListener);
        };
    }, []);
    return isMouseDown;
}
